module.exports = __webpack_public_path__ + "static/img/logo_white.65ebc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_white.png
// module id = AtLS
// module chunks = 13